<template>
    <div class="form-inline">
        <div class="form-group">
            <label class="checkbox-switcher" :class="{ 'checkbox-left-aligned': textPullLeft }">
                <input
                        type="checkbox"
                        :checked="isChecked"
                        @change="update"
                        :disabled="disabled"
                >
                <span class="checkbox-slider round"></span>
            </label>
        </div>
        <div v-if="labelText" class="form-group" :class="{ 'pull-left': textPullLeft }">
            <label class="switcher-text-label" :class="{ 'left-aligned': textPullLeft }" :style="labelInlineStyle">{{ labelText }}</label>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheckboxSwitcher',
        props: {
            disabled: {default: false},
            isChecked: {default: false},
            labelInlineStyle: {type: Object},
            labelText: {required: false},
            textPullLeft: {default: false}
        },
        data() {
            return {}
        },
        methods: {
            update() {
                this.$emit('update:isChecked', !this.isChecked)
            }
        }
    };
</script>

<style scoped>
    /* The switch - the box around the slider */
    .checkbox-switcher {
        position: relative;
        display: inline-block;
        width: 36px;
        height: 18px;
    }
    .checkbox-switcher.checkbox-left-aligned {
        margin-top: 1px;
    }
    /* Hide default HTML checkbox */
    .checkbox-switcher input {display:none;}
    /* The slider */
    .checkbox-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }
    .checkbox-slider:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 3px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    .checkbox-switcher input:checked + .checkbox-slider {
        background-color: #2196F3;
    }
    .checkbox-switcher input:focus + .checkbox-slider {
        box-shadow: 0 0 1px #2196F3;
    }
    .checkbox-switcher input:checked + .checkbox-slider:before {
        -webkit-transform: translateX(16px);
        -ms-transform: translateX(16px);
        transform: translateX(16px);
    }
    .checkbox-switcher input:disabled + .checkbox-slider {
        background-color: #999;
    }
    /* Rounded sliders */
    .checkbox-slider.round {
        border-radius: 84px;
    }
    .checkbox-slider.round:before {
        border-radius: 50%;
    }
    .switcher-text-label {
        margin: 0 15px 0 6px;
        font-size: 12px;
        font-weight: 600;
        color: #9b9b9b;
    }
    .switcher-text-label.left-aligned {
        margin: 0 15px 12px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/checkbox-switcher.vue